/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

import Buttons from "../../../../components/ui/button/Buttons";
import CardSection from "../../../../components/ui/card/CardSection";
import DropdownSelect from "../../../../components/ui/dropdown/DropdownSelect";
import { useLazyGetAllRolesQuery } from "../../../../app/services/securityPermissionAPI";
import { decryptUrlData } from "../../../../services/CryptoService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ManagePermission from "./features/ManagePermission";
import "./SecurityPermission.scss";

const SecurityPermission = () => {
  const { id } = useParams();
  const childRef = useRef();
  const navigate = useNavigate();
  const roleId = id ? decryptUrlData(id) : 0;
  const [rolesList, setRolesList] = useState([]);
  const location = useLocation();
  const [selecteRoleId, setSelecteRoleId] = useState(roleId ? { value: roleId, label: "" } : null);
  const [togglePermissionCard, setTogglePermissionCard] = useState(false);

  const [getAllRoles, {
    data: isAllRolesData,
    isSuccess: isSuccessAllRoles,
    isFetching: isFetchingAllRoles
  }] = useLazyGetAllRolesQuery();

  const handalDropDownChange = (selectedOption) => {

    setSelecteRoleId(selectedOption);
    setTogglePermissionCard(false);
  };

  const handleClick = () => {
    if (selecteRoleId) {
      setTogglePermissionCard(true);
      if (childRef.current) {
        childRef.current.callChildFunction(selecteRoleId);
      }
    }
  };

  const handleBackButton = () => {
    navigate('/admin/roles');
  }

  useEffect(() => {
    getAllRoles();
  }, [roleId]);

  useEffect(() => {

    if (isSuccessAllRoles && isAllRolesData && !isFetchingAllRoles) {
      const roleList = isAllRolesData?.map((item) => ({
        value: item.roleId,
        label: item.roleName,
      }));
      setRolesList(roleList);
      if (roleId > 0) {
        const selectedRole = roleList.find((role) => role.value === roleId);
        if (selectedRole) {
          setSelecteRoleId(selectedRole);

        }
      }
    }
  }, [isSuccessAllRoles, isAllRolesData, isFetchingAllRoles]);

  useEffect(() => {
    if (roleId > 0) {
      setSelecteRoleId({
        value: roleId,
        label: "",
      });
    }
    getAllRoles();
  }, []);



  useEffect(() => {
    if (!id) {
      setSelecteRoleId(0);
      setTogglePermissionCard(false);
    }
  }, [id, location.pathname]);

  return (
    <div className="center-top-space">
      <CardSection
        isContentLoading={isFetchingAllRoles}
        className="mt-4"
        cardTitle="Security Roles"
        titleButtonClick={handleBackButton}
        iconName="ri:profile-line"
        rightButton={true}
        buttonText="Go Back"
        buttonClassName="dark-btn"
      >
        <div className="row">
          <div className='col-lg-6 col-md-6'>
            <DropdownSelect
              value={selecteRoleId}
              placeholder={"Please Select Role"}
              optionsValue={rolesList}
              handleDropdownChange={handalDropDownChange}
            />
          </div>
          <Buttons
            buttonTypeClassName="btn theme-btn "
            buttonText="Show Permission"
            onClick={handleClick}
          />

        </div>

      </CardSection>

      <ManagePermission togglePermissionCard={togglePermissionCard} selecteRoleId={selecteRoleId} childRef={childRef} />
    </div>
  )

}
export default SecurityPermission;